export const BROWSER_TILE_KEYS = {
  SelfCustody: "selfCustody",
  Versatility: "versatility",
  Privacy: "privacy",
}
